/* Wear Sassy cart upsell: quick-add for WRAP IT UP products from the cart drawer. */
(function () {
  if (window.__wsUpsellInit) return;
  window.__wsUpsellInit = true;
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('.ws-upsell__add') : null;
    if (!btn || btn.disabled) return;
    btn.disabled = true;
    btn.textContent = '…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: Number(btn.dataset.wsVariant), quantity: 1 })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      })
      .then(function () {
        btn.textContent = 'ADDED';
        document.dispatchEvent(
          new CustomEvent('cart:update', {
            detail: { sourceId: 'ws-upsell', data: { source: 'ws-upsell' } }
          })
        );
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = 'ADD';
      });
  });
})();
